/* eslint-disable @typescript-eslint/no-explicit-any */
export const APP_EVENTS = {
  OPEN_LINK: 'href',
  START: 'start',
  SET_USER_ID: 'userid',
  TOGGLE_SCREENSHOT: 'screenshot',
  REFRESH: 'refresh',
};

export function spawnAppEvent(event: any, data: any = '') {
  if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(`${event}:::${data}`);
}
